import React from 'react';
import { Textarea, TextareaProps as ChakraTextareaProps } from '@chakra-ui/react';

export type TextAreaProps = ChakraTextareaProps

export const TextArea = ({
    ...restProps
}: TextAreaProps) => (
    <Textarea
        border="1px solid black"
        fontSize="1.5rem"
        borderRadius={0}
        padding="1rem"
        {...restProps}
    />
);
